exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.asignacionNoSeriado .estilo-grilla,\n.asignacionNoSeriado #gridComponent {\n  height: auto !important;\n  margin-bottom: 50px;\n}\n.sav_crm .ag-pinned-left-cols-container,\n.sav_crm .ag-pinned-left-header {\n  display: none;\n}\n", ""]);

// exports
